module.exports = __webpack_public_path__ + "images/supplementarybenefit.svg?331b165ef7355a183a01074d95ad2216";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplementarybenefit.svg
// module id = jVX2
// module chunks = 0